var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86332 17.9999C9.58732 17.9999 9.32332 17.8859 9.13432 17.6849L4.27132 12.5059C3.89232 12.1039 3.91332 11.4709 4.31532 11.0929C4.71832 10.7149 5.35132 10.7349 5.72832 11.1369L9.85332 15.5279L18.2613 6.32587C18.6353 5.91687 19.2673 5.88987 19.6753 6.26187C20.0823 6.63387 20.1103 7.26687 19.7383 7.67387L10.6013 17.6739C10.4143 17.8799 10.1483 17.9979 9.87032 17.9999H9.86332Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.24c7865097a5edf9e5885f1e9a839945.svg";
export { ForwardRef as ReactComponent };